// Định dạng số vi-VN (UI_SPEC §14): đầy đủ dùng dấu chấm phân nhóm, rút gọn theo Vạn / Ức.
import { t } from './t';

const FULL = new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 2 });
const SIG3 = new Intl.NumberFormat('vi-VN', { maximumSignificantDigits: 3 });

/** Đầy đủ: 1.234.567 · 3,25 */
export function formatFull(n: number): string {
  return FULL.format(n);
}

const UNITS: readonly { pow: number; key: string }[] = [
  { pow: 16, key: 'ui.num.jing' },
  { pow: 12, key: 'ui.num.wanYi' },
  { pow: 8, key: 'ui.num.yi' },
  { pow: 4, key: 'ui.num.wan' },
];

/** Rút gọn: < 10.000 in đầy đủ; từ 10⁴ dùng Vạn / Ức / Vạn Ức / Kinh, 3 chữ số có nghĩa. */
export function formatCompact(n: number): string {
  const abs = Math.abs(n);
  if (abs < 1e4) return FULL.format(Math.floor(n));
  for (const u of UNITS) {
    if (abs >= Math.pow(10, u.pow)) {
      const v = n / Math.pow(10, u.pow);
      // 3 chữ số có nghĩa, không làm tròn lên thành đơn vị kế (999,99 Vạn giữ 999 Vạn).
      const digits = Math.floor(Math.log10(Math.abs(v))) + 1;
      const f = Math.pow(10, Math.max(0, 3 - digits));
      const cut = Math.trunc(v * f + 1e-9) / f;
      // Phần nguyên dài hơn 3 chữ số (vd 9.999 Vạn) thì in nguyên, không để SIG3 làm tròn lên.
      return `${digits > 3 ? FULL.format(cut) : SIG3.format(cut)} ${t(u.key)}`;
    }
  }
  return FULL.format(n);
}
